var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60698",
    "data-name": "Group 60698",
    transform: "translate(-4121 -8201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ef075209c8d09f619506f4f2a4d757f9",
    d: "M22.506,17.438h-.729a3.664,3.664,0,0,0-.485-1.161l.516-.517a.814.814,0,1,0-1.151-1.151l-.516.517a3.674,3.674,0,0,0-1.161-.485v-.729a.814.814,0,1,0-1.627,0v.729a3.674,3.674,0,0,0-1.161.485l-.516-.517a.814.814,0,1,0-1.151,1.151l.516.517a3.674,3.674,0,0,0-.485,1.161h-.729a.814.814,0,0,0,0,1.627h.729a3.664,3.664,0,0,0,.485,1.161l-.516.517a.814.814,0,1,0,1.15,1.151l.516-.517a3.674,3.674,0,0,0,1.161.485v.729a.814.814,0,0,0,1.627,0v-.729a3.674,3.674,0,0,0,1.161-.485l.516.517a.814.814,0,1,0,1.15-1.151l-.516-.517a3.674,3.674,0,0,0,.485-1.161H22.5a.814.814,0,1,0,0-1.627Zm-2.875,2.278a.246.246,0,0,0-.014.022,2.067,2.067,0,0,1-2.9,0,.246.246,0,0,1-.014-.022c-.005-.007-.015-.009-.022-.014a2.067,2.067,0,0,1,0-2.9c.007-.007.015-.008.022-.014a.245.245,0,0,0,.014-.022,2.067,2.067,0,0,1,2.9,0,.246.246,0,0,1,.014.022c.005.007.015.009.022.014a2.067,2.067,0,0,1,0,2.9C19.647,19.709,19.638,19.71,19.631,19.716Zm-6.889-7.16A5.153,5.153,0,1,1,17.9,7.4,5.159,5.159,0,0,1,12.743,12.556Zm0-8.679A3.526,3.526,0,1,0,16.268,7.4,3.53,3.53,0,0,0,12.743,3.877Zm-.3,18.714a.814.814,0,0,0-.814-.814H6.233a1.358,1.358,0,0,1-1.356-1.356,4.616,4.616,0,0,1,4.611-4.611h2.17a.814.814,0,1,0,0-1.627H9.488A6.245,6.245,0,0,0,3.25,20.422,2.986,2.986,0,0,0,6.233,23.4h5.392a.814.814,0,0,0,.814-.814Z",
    transform: "translate(4119.716 8200.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 24,
    height: 24,
    transform: "translate(4121 8201)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/userSetting.1d7ee2a9a8cafcb2d91e34697b217bac.svg";
export { ForwardRef as ReactComponent };